import React, {Component} from 'react';
import InputGroup from './InputGroup';
import NestedUtils from './NestedUtils';
import ButtonGroup from './ButtonGroup';
import {injectIntl} from 'react-intl';
import {messages, messagePropType} from '../common/Translations';
import PropTypes from 'prop-types';

/**
 * @property {Array }           data                   The data containing hierarchy of strings to find
 * @property {Array}            selection              Ids of the (initially) selected data
 *                                                     Hint system will try to find object properties according
 *                                                     to specified entry keys.
 * @property {string}
 */
export class MultistepSelect extends Component {

    constructor(props) {
        super(props);
        this.nestedUtils = new NestedUtils(this.props.data);
        this.state = {current: null, selectionDisabled: false};
    }

    componentWillReceiveProps(nextProps) {
        // set data to utility when the component data prop is updated
        //@TODO check if the data changed
        this.nestedUtils.data = nextProps.data;
    }

    onConfirm(e) {
        this.props.onConfirm(this.state.current);
        this.setState({current: null, selectionDisabled: false});
    }

    onSelect(current) {
        this.setState({current});
        if (this.props.onSelect) {
            this.props.onSelect(current);
        }
    }

    onRemove(value) {
        this.props.onRemove(value);
    }

    onReset() {
        this.setState({current: null, selectionDisabled: false});
        this.props.onReset && this.props.onReset();
    }

    renderSelectedItems() {

        const SelectedItemsComponent = this.props.selectedListComponent;

        return (
            <SelectedItemsComponent
                nestedUtils={this.nestedUtils}
                selection={this.props.selection}
                onRemove={this.onRemove.bind(this)}
                deleteButtonText={'remove'}
            />
        );
    }

    renderDisabledItems() {
        const DisabledListComponent = this.props.disabledListComponent;

        return (
            <DisabledListComponent
                nestedUtils={this.nestedUtils}
                selection={this.props.selection}
            />
        );
    }

    renderSelects() {
        if (this.isMaxCount()) {
            return null;
        }

        let error = this.props.meta.touched && this.props.meta.error;

        return (
            <InputGroup
                data={this.props.data}
                current={this.state.current}
                onSelect={this.onSelect.bind(this)}
                onRemove={this.props.onRemove}
                error={error}
                placeholder={this.props.placeholder}
                creatable={this.props.creatable}
                maxCreatableLength={this.props.maxCreatableLength}
                selectionDisabled={this.state.selectionDisabled}
            />
        );
    }

    formatConfirmBtnText(item) {
        const rootMsgDescriptor = this.props.confirmBtnRootMsg || messages.multistepSelectButtonSelectionPlaceholder;
        const subMsgDescriptor = this.props.confirmBtnSubMsg || messages.multistepSelectButtonSelectionPlaceholder;

        const rootItemConfirmText = this.props.intl.formatMessage(rootMsgDescriptor, {selectedItemName: item.name});
        const subItemConfirmText = this.props.intl.formatMessage(subMsgDescriptor, {selectedItemName: item.name});

        if (item.custom) {
            return rootItemConfirmText;
        }

        return this.nestedUtils.hasParent(item.id) ? subItemConfirmText : rootItemConfirmText;
    }

    renderButtons() {
        const item = this.state.current;

        if (!item || item.name == '') {
            return null;
        }

        let selectedItem, itemHasChildren;

        if (!item.custom) {
            //@TODO Refactor. [item] contains item id in this case / branch.
            selectedItem = this.nestedUtils.findItemById(item);
            itemHasChildren = this.nestedUtils.hasChildren(item);
        } else {
            selectedItem = item;
            itemHasChildren = false;
        }

        const confirmText = this.formatConfirmBtnText(selectedItem);

        return <ButtonGroup
            onReset={this.onReset.bind(this)}
            onConfirm={this.onConfirm.bind(this)}
            selectedItemName={selectedItem.name}
            itemHasChildren={itemHasChildren}
            readyToConfirm={!!item}
            confirmText={confirmText}
            disableParentSelect={this.props.disableParentSelect}
        />
    }

    render() {
        if (!this.props.disabled || this.props.disabledListComponent === undefined) {
            return typeof this.props.children === "function" ?

                this.props.children(
                    this.renderSelects(),
                    this.renderSelectedItems(),
                    this.renderButtons(),
                    (customItem, selectionDisabled = true) => {
                        this.setState({current: customItem, selectionDisabled});
                    },
                ) :
                <div>
                    {this.renderSelects()}
                    {this.renderButtons()}
                    {this.renderSelectedItems()}
                </div>
        } else {
            return (
                <div>
                    {this.renderDisabledItems()}
                </div>
            )
        }
    }

    componentDidUpdate() {
        const {
            maxCount,
            input: {
                value
            }
        } = this.props;

        if (this.isMaxCount() && maxCount < value.length) {
            this.props.input.onChange(this.props.selection.slice(0, this.props.maxCount));
        }
    }

    isMaxCount() {
        const {
            maxCount,
            input: {
                value
            }
        } = this.props;

        return !!(maxCount && Array.isArray(value) && maxCount <= value.length /*&& !this.props.isAdmin*/);
    }

}

MultistepSelect.defaultProps = {
    buttonPosition: 'top',
    data: [],
    input: {},
    meta: {},
    selection: []
};

const itemShape = {
    id: PropTypes.number,
    name: PropTypes.string,
    parentId: PropTypes.number,
    children: PropTypes.arrayOf(PropTypes.number)
};

MultistepSelect.propTypes = {
    buttonPosition: PropTypes.oneOf(['top', 'bottom']),
    data: PropTypes.arrayOf(PropTypes.shape(itemShape)),
    maxCount: PropTypes.number,
    onSelect: PropTypes.func,
    onRemove: PropTypes.func,
    confirmBtnRootMsg: messagePropType,
    confirmBtnSubMsg: messagePropType,
    selectedListComponent: PropTypes.func.isRequired,
    selection: PropTypes.array,
    disableParentSelect: PropTypes.bool,
    disabled: PropTypes.bool
};

export default injectIntl(MultistepSelect);


// WEBPACK FOOTER //
// ./web/src/components/multistep-select/MultistepSelect.jsx